import { useEffect, useRef } from 'react';
import { useToolResult } from '../contexts/ToolResultContext';

/**
 * Hook to automatically publish the latest tool analysis result to Emma.
 * Usage: usePublishToEmma('AI Cashflow Predictor', analysis);
 * 
 * @param {string} toolName - Name of the tool
 * @param {string|null} result - Latest analysis text (null = no result yet)
 */
export function usePublishToEmma(toolName, result) {
  const { publishResult, clearResult } = useToolResult();
  const prevResult = useRef(null);

  useEffect(() => {
    if (result && result !== prevResult.current) {
      // Truncate to keep prompt size manageable
      const summary = typeof result === 'string'
        ? result.slice(0, 4000)
        : JSON.stringify(result).slice(0, 4000);
      publishResult(toolName, summary);
      prevResult.current = result;
    }
  }, [result, toolName, publishResult]);

  // Clear on unmount
  useEffect(() => {
    return () => clearResult();
  }, [clearResult]);
}
